import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=18d82bbb"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d82bbb')) {
      api.createRecord('18d82bbb', component.options)
    } else {
      api.reload('18d82bbb', component.options)
    }
    module.hot.accept("./DropFile.vue?vue&type=template&id=18d82bbb", function () {
      api.rerender('18d82bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DropFile.vue"
export default component.exports